import { z } from "zod";

export const PERMISSION_IDS = [
  "workspace_management",
  "view_audit_logs",
  "manage_approvals",
  "run_test",
  "edit_test",
  "edit_control",
  "edit_workstep",
  "edit_workstep_test",
  "run_workstep_test",
] as const;

export type PermissionId = (typeof PERMISSION_IDS)[number];

// Permissive at parse time so a new backend permission the frontend doesn't
// yet know about (e.g. a future split-out gate) doesn't break /user/ and
// /workspace/roles parsing for every user. Narrow PermissionId is still used
// at call sites for known gates.
export const PermissionIdSchema = z.string();
